import config from "config";

function localhostGcuiAuthKeyForEnvironment(env) {
    switch (env) {
        case "tca":
            return "gcui_auth-localhost-tca";
        case "pca":
            return "gcui_auth-localhost-pca";
        default:
            return "gcui_auth-localhost-dca";
    }
}

/**
 * Get authentication token from localStorage for local development.
 * Returns the raw access token string.
 *
 * @returns {string} The access token string
 * @throws {Error} If token is not available
 */
export default function getGcuiAuthToken() {
    const { appVersion } = config;
    const oAuthKey =
        appVersion === "dev"
            ? localhostGcuiAuthKeyForEnvironment(config.env)
            : "gcui_auth";

    const gcuiAuth = localStorage.getItem(oAuthKey);
    if (!gcuiAuth) {
        throw new Error(
            `Failed to retrieve auth data from localStorage (key: ${oAuthKey}, version: ${appVersion})`
        );
    }

    return gcuiAuth;
}
